import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { SocialDistributionState } from '../types'

const publishedGroup: Getter<SocialDistributionState, RootState> = (state) => {
  return state.publishedGroup
}

export default publishedGroup
